import React, { Component } from "react";
import axios from "axios";
import UserList from "./UserList";
import { LangContext } from "../LangContext.jsx";

class UsersPanel extends Component {
  static contextType = LangContext;

  constructor(props) {
    super(props);
    this.state = {
      search: "",
      members: [],
      invitations: [],
      activeTab: "members",
    };
  }

  getMembers = async () => {
    const { search } = this.state;
    const URL = search !== "" ? `/api/users?search=${search}` : '/api/users';
    const membersResponse = await axios.get(URL);
    this.setState({ members: membersResponse.data });
  };

  getInvitations = async () => {
    const { search } = this.state;
    const URL = search !== "" ? `/api/users/invitations?search=${search}` : '/api/users/invitations';
    const invitationsResponse = await axios.get(URL);
    this.setState({ invitations: invitationsResponse.data });
  };

  handleSearch = (ev) => {
    const { value } = ev.target;
    this.setState({ search: value });
  };

  handleSwitch = async (ev, userId, roleId) => {
    const URL = `/api/users/edit/${userId}`;
    await axios.post(URL, { role_id: roleId, status: 1 });
  };

  handleSwitchTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  componentDidMount() {
    this.getMembers();
    this.getInvitations();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.search !== this.state.search) {
      this.getMembers();
      this.getInvitations();
    }
  }

  render() {
    const { lang } = this.context;
    const { members, invitations, activeTab } = this.state;
    const { isowner, permissions } = this.props;
    return (
      <div className="d-flex flex-column-fluid">
        <div className="container">
          <div className="card card-custom gutter-b">
            <div className="card-body">
              <div className="row">
                <div className="col-sm-4"></div>
                <div className="col-sm-4"></div>
                <div className="col-sm-4">
                  <div className="input-icon">
                    <input
                      onChange={this.handleSearch}
                      type="text"
                      className="form-control"
                      placeholder={lang.get('messages.buscar_usuarios')}
                    />
                    <span>
                      <i className="flaticon2-search-1 text-primary icon-md"></i>
                    </span>
                  </div>
                </div>
              </div>

              <ul className="nav nav-tabs nav-tabs-line mb-4">
                <li className="nav-item">
                  <a
                    onClick={() => this.handleSwitchTab('members')}
                    style={{ cursor: 'pointer' }}
                    className={`nav-link ${activeTab === 'members' ? 'active' : ''}`}
                    data-toggle="tab"
                  >
                    {lang.get('messages.usuarios')} &nbsp;
                    <span className="badge badge-secondary">{members.length}</span>
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    onClick={() => this.handleSwitchTab('invitations')}
                    className={`nav-link ${activeTab === 'invitations' ? 'active' : ''}`}
                    style={{ cursor: 'pointer' }}
                    data-toggle="tab"
                  >
                    {lang.get('messages.invitaciones')} &nbsp;
                    <span className="badge badge-secondary">{invitations.length}</span>
                  </a>
                </li>
              </ul>

              {activeTab === 'members' && (
                <UserList
                  users={members}
                  isOwner={isowner}
                  permissions={permissions}
                  handleSwitch={this.handleSwitch}
                  disableActions={false}
                />
              )}
              {activeTab === 'invitations' && (
                <UserList
                  users={invitations}
                  isOwner={isowner}
                  permissions={permissions}
                  disableActions={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UsersPanel;
